import App from './App'
import hooks from '../../hooks'
import AuthModule from '../../modules/common/init/init-auth'

const el = document.getElementById('app')

const panel = new AuthModule()

panel.bootfiles.push(...hooks)

panel.install({
  el,
  render: (h) => {
    return h(App, {
      props: {
        initialPage: JSON.parse(el.dataset.page)
      }
    })
  }
})
